<template>
  <div class="template-wrapper" id="stopped">
    <div id="left-menu">
      <e-left-menu />
    </div>

    <div id="main-content" class="main-content">
      <v-app-bar
        id="app-bar"
        elevate-on-scroll
        width="100%"
        style="overflow: hidden"
        class="app-bar-premium justify-sm-space-between"
      >
        <v-btn id="menu-toggle-button" icon class="app-bar-icon-btn mr-2" @click="toggleMenu">
          <v-icon color="white">mdi-menu</v-icon>
        </v-btn>

        <span
          id="franquia-description"
          class="franquia-badge d-none d-sm-flex align-center"
          v-if="!hideFranquia"
        >
          <v-icon small class="mr-1" color="white">mdi-domain</v-icon>
          {{ user ? user?.franquia?.descricao : "..." }}
        </span>

        <v-spacer></v-spacer>

        <e-notificacoes-list></e-notificacoes-list>

        <e-tema-toggle icon-color="white" btn-class="app-bar-icon-btn mx-2" />

        <v-list id="user-menu" color="transparent" max-width="260px" class="pa-0">
          <v-menu offset-y content-class="user-dropdown">
            <template v-slot:activator="{ on, attrs }">
              <v-list-item id="user-menu-activator" v-bind="attrs" v-on="on">
                <v-list-item-avatar>
                  <e-user-avatar current />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title id="user-name" class="white--text">
                    {{ (user ? user.name : "Carregando...") | truncate(15) }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <e-user-role :value="user" link />
                  </v-list-item-subtitle> </v-list-item-content
                ><v-list-item-action>
                  <v-icon color="white">mdi-menu-down</v-icon>
                </v-list-item-action>
              </v-list-item>
            </template>

            <v-list dense>
              <v-list-item
                id="change-school-unit"
                dense
                link
                v-if="isSuperAdmin"
                @click="openSelecionarFranquiaModal = true"
              >
                <v-list-item-avatar>
                  <v-icon small>fa fa-cogs</v-icon>
                </v-list-item-avatar>
                <v-list-item-title>Alterar unidade franquia</v-list-item-title>
              </v-list-item>
              <v-list-item id="change-password" dense link @click="openAtualizarSenhaModal = true">
                <v-list-item-avatar>
                  <v-icon small>fa fa-key</v-icon>
                </v-list-item-avatar>
                <v-list-item-title>Alterar senha</v-list-item-title>
              </v-list-item>
              <v-list-item id="logout" dense link :to="{ name: 'logout' }">
                <v-list-item-avatar>
                  <v-icon small>mdi-logout</v-icon>
                </v-list-item-avatar>
                <v-list-item-title>Sair</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-list>
      </v-app-bar>

      <v-dialog id="session-expiration-dialog" v-model="modalOcioso" persistent max-width="480">
        <v-card>
          <div class="session-dialog-orb"></div>
          <v-card-text class="text-center pt-6">
            <div class="session-dialog-icon">
              <v-icon large>mdi-timer-sand</v-icon>
            </div>
            <div class="session-dialog-title">Sua sessão está próxima de expirar!</div>
            <div class="session-dialog-text">
              Está faltando

              <v-chip
                id="session-time-chip"
                color="#f59e0b"
                text-color="white"
                class="ma-2 font-weight-bold"
              >
                {{ this.tempoFormatado }}
              </v-chip>

              segundos.
            </div>
          </v-card-text>
          <v-card-actions class="justify-center pb-5">
            <v-btn
              id="stay-logged-in-button"
              color="primary"
              class="white--text font-weight-bold text-capitalize"
              rounded
              @click="
                limparIntervalo(idInterval);
                dataInicial();
                temporizador();
                modalOcioso = false;
              "
            >
              Permanecer logado
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-system-bar id="system-bar" height="32" class="system-bar d-flex align-center">
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <span id="session-time-label" class="session-label mr-2">Tempo de sessão</span>
        <span class="session-chip">
          <v-icon x-small class="mr-1">mdi-timer-outline</v-icon>
          <span id="session-time">{{ tempoFormatado }}</span>
        </span>
      </v-system-bar>

      <v-container id="main-container">
        <slot />
        <v-row id="footer-row" style="min-height: 90px">
          <v-col>
            <span></span>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <e-change-password-modal id="change-password-modal" v-model="openAtualizarSenhaModal" />
    <e-selecionar-franquia-modal
      id="select-school-unit-modal"
      v-model="openSelecionarFranquiaModal"
    />

    <e-data-comemorativa-tema />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import EChangePasswordModal from "../../../components/EChangePasswordModal.vue";

const exibirFinanceiro = process.env.VUE_APP_ATIVAR_FINANCEIRO === "true";
export default {
  name: "MainTemplate",
  components: {
    EChangePasswordModal,
    // ENotificacoesList,
  },
  props: {
    hideFranquia: {
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
    ...mapGetters("Franquias", ["franquias"]),
    ...mapGetters("MainTemplate", ["menuOpen"]),
    isSuperAdmin() {
      if (this.user?.roleName === "super-admin") return true;
      if (Array.isArray(this.user?.roles)) {
        return this.user.roles.some((role) => role.name === "super-admin");
      }
      return false;
    },
  },
  mounted() {
    // this.$Tawk.$setOnLoadFunction(() => this.$Tawk.$showWidget());
    this.dataInicial();
    this.temporizador();

    const para1 = document.getElementById("para1");
    this.animate(para1);
  },
  data() {
    return {
      permitirEdicaoAlert: false,
      botaoAlerta: true,
      novoAlerta: false,
      textoMensagemAlerta: null,
      idInterval: null,
      modalOcioso: false,
      active: false,
      tempo: null,
      tempoFormatado: null,
      durabilidadeDaVidaDoUsuario: 0,
      ex1: { label: "Life", val: 100, color: "orange" },
      selectedItem: 0,
      openAtualizarSenhaModal: false,
      openSelecionarFranquiaModal: false,
      exibirFinanceiro,
      menu: {
        items: [
          {
            icon: "fa fa-home",
            title: "Início",
            exibir: true,
            children: [{ title: "Ir para Início", to: { name: "home" }, icon: "" }],
          },
          {
            icon: "fa fa-user-graduate",
            title: "Matrículas",
            exibir: true,
            children: [
              { title: "Ver Matrículas", to: { name: "matriculas" }, icon: "" },
              // { title: "Adicionar matricula", to: "#", icon: "" },
              { title: "Ver Alunos", to: { name: "alunos" }, icon: "" },
              { title: "Pesquisa avançada", to: { name: "alunos-pesquisa-avancada" }, icon: "" },
            ],
          },
          {
            icon: "fa fa-graduation-cap",
            title: "Turmas",
            exibir: true,
            children: [
              { title: "Ver turmas", to: { name: "turmas" }, icon: "" },
              // { title: "Adicionar turmas", to: "#", icon: "" },
              // { type: "spacer" },
              {
                title: "Gestão de anos",
                to: { name: "series" },
                icon: "fa fa-bookmark",
                permissions: ["series.*", "series.criar"],
              },
              {
                title: "Componentes Curricularers",
                to: { name: "disciplinas" },
                icon: "fa fa-bookmark",
                permissions: ["disciplinas.*", "disciplinas.criarDisciplina"],
              },
              // { title: "Gestão de disciplinas", to: "#", icon: "" },
              // { title: "Gestão de cursos", to: "#", icon: "" },
            ],
          },
          {
            icon: "fa fa-chalkboard-teacher",
            title: "Diário online",
            exibir: true,
            children: [
              {
                title: "Listar todos",
                to: { name: "gestoesDeAulas" },
                icon: "",
                permissions: ["gestoesDeAulas.*", "gestoesDeAulas.criar"],
              },
            ],
          },
          {
            icon: "fa fa-users",
            title: "Usuários",
            exibir: true,
            children: [
              {
                title: "Ver Professores",
                to: { name: "professores" },
                icon: "fa fa-user-tie",
                permissions: ["users.*"],
              },
              {
                title: "Outros",
                to: { name: "usuarios" },
                icon: "fa fa-bookmark",
                permissions: ["users.*"],
              },
            ],
          },
          {
            icon: "fa fa-money",
            title: "Financeiro",
            exibir: exibirFinanceiro,
            children: [
              {
                title: "Mensalidades",
                to: { name: "mensalidades" },
                permissions: "financeiro.baixarParcela",
                icon: "",
              },
              {
                title: "Gestão de Caixas",
                to: { name: "caixas" },
                permissions: "caixas.abrir",
                icon: "",
              },
            ],
          },
          {
            icon: "mdi-account-network",
            title: "Administração",
            exibir: true,
            children: [
              {
                title: "Franquias",
                to: { name: "franquias" },
                permissions: ["franquias.*", "franquias.criarFranquia"],
                icon: "",
              },
              // {
              //   title: "Inep",
              //   to: { name: "inep" },
              //   icon: "",
              // },
            ],
          },
        ],
        width: "250px",
      },
    };
  },
  methods: {
    block() {
      this.botaoAlerta = false;
    },
    toggleMenu() {
      this.$store.commit("MainTemplate/setMenuOpen", !this.menuOpen);
    },
    dataInicial() {
      const data = Date.now();
      const dataConvertida = new Date(data);
      // dataConvertida.setTime(0);
      dataConvertida.setHours(0);
      dataConvertida.setMinutes(0);
      dataConvertida.setSeconds(0);
      // estabeler temporizador
      dataConvertida.setMinutes(this.durabilidadeDaVidaDoUsuario);
      dataConvertida.setHours(6);
      this.tempo = dataConvertida;
    },
    temporizador() {
      this.idInterval = setInterval(() => {
        const data = new Date(this.tempo);
        data.setSeconds(data.getSeconds() - 1);
        this.tempo = data.toISOString();
        const h = this.zeroFill(data.getHours());
        const m = this.zeroFill(data.getMinutes());
        const s = this.zeroFill(data.getSeconds());
        this.tempoFormatado = `${h}:${m}:${s}`;

        const somaTempo = parseInt(
          this.zeroFill(data.getHours()) +
            this.zeroFill(data.getMinutes()) +
            this.zeroFill(data.getSeconds()),
          10
        );

        if (parseInt(h, 10) === 0 && parseInt(m, 10) === 0 && parseInt(s, 10) === 0) {
          this.$router.push({ name: "logout" });
          return;
        }

        if (!somaTempo) {
          this.limparIntervalo(this.idInterval);
        }

        if (parseInt(h, 10) === 0 && parseInt(m, 10) === 10 && parseInt(s, 10) === 0) {
          this.modalOcioso = true;
        }
      }, 1000);
    },
    limparIntervalo(idInterval) {
      clearInterval(idInterval);
    },
    zeroFill(n) {
      return n <= 9 ? `0${n}` : `${n}`;
    },
    animate(element) {
      if (!element) return;
      const elementWidth = element.offsetWidth ? element.offsetWidth : "";
      const parentWidth = element.parentElement.offsetWidth
        ? element.parentElement.offsetWidth
        : "";
      let flag = 0;

      setInterval(() => {
        element.style.marginLeft = `${flag - 1}px`;

        if (elementWidth === -flag) {
          flag = parentWidth;
        }
      }, 10);
    },
  },
};
</script>

<style>
#main-content {
  background: linear-gradient(180deg, var(--surface-2) 0%, var(--surface) 240px);
}

.app-bar-premium {
  background: linear-gradient(
    90deg,
    var(--brand-grad-1) 0%,
    var(--brand-grad-2) 50%,
    var(--brand-grad-3) 100%
  ) !important;
  box-shadow: 0 2px 12px rgba(79, 0, 143, 0.25) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.app-bar-premium::before {
  content: "";
  position: absolute;
  top: -70px;
  right: -40px;
  width: 240px;
  height: 180px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.14), transparent 70%);
  pointer-events: none;
}

.app-bar-premium .app-bar-icon-btn {
  background: rgba(255, 255, 255, 0.14) !important;
  border-radius: 10px;
  transition: background-color 0.18s ease, transform 0.18s ease !important;
}

.app-bar-premium .app-bar-icon-btn:hover {
  background: rgba(255, 255, 255, 0.28) !important;
  transform: scale(1.05);
}

.franquia-badge {
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #ffffff;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.2px;
  line-height: 1.2;
}

/* ===== USUÁRIO / DROPDOWN ===== */
.app-bar-premium #user-menu .v-list-item {
  border-radius: 10px;
  transition: background-color 0.18s ease;
}

.app-bar-premium #user-menu .v-list-item:hover {
  background-color: rgba(255, 255, 255, 0.14) !important;
}

.user-dropdown {
  border-radius: 14px !important;
  border: 1px solid var(--border) !important;
  box-shadow: 0 18px 44px rgba(79, 0, 143, 0.14) !important;
  overflow: hidden;
  padding: 6px;
  background: var(--surface) !important;
}

.user-dropdown .v-list {
  background: transparent !important;
}

.user-dropdown .v-list-item {
  border-radius: 9px;
  margin: 1px 0;
  min-height: 40px !important;
  transition: background-color 0.15s ease;
}

.user-dropdown .v-list-item:hover {
  background-color: rgba(124, 58, 237, 0.08) !important;
}

.user-dropdown .v-list-item .v-list-item__title {
  font-size: 13.5px;
  font-weight: 500;
  color: var(--text-2);
}

.user-dropdown .v-list-item:hover .v-list-item__title {
  color: var(--brand);
}

.user-dropdown .v-list-item__avatar {
  width: 30px !important;
  height: 30px !important;
  background: var(--brand-soft-2);
  border-radius: 9px;
  color: var(--brand) !important;
}

.user-dropdown .v-list-item__avatar .v-icon {
  font-size: 14px;
  color: var(--brand);
}

.system-bar {
  background: linear-gradient(90deg, #1c1238 0%, #2b1b5c 55%, #3a2378 100%) !important;
  color: #ffffff !important;
  font-size: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.system-bar .session-label {
  color: rgba(255, 255, 255, 0.85);
  font-weight: 500;
}

.system-bar .session-chip {
  display: inline-flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 12px;
  padding: 5px 12px;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: 0.5px;
  margin-bottom: 2px;
}

.system-bar .session-chip .v-icon {
  color: #fbbf24 !important;
}

.system-bar .session-chip #session-time {
  margin-left: 6px;
  font-variant-numeric: tabular-nums;
}

#session-expiration-dialog .v-card {
  border-radius: 20px !important;
  border: 1px solid var(--border);
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.18) !important;
  position: relative;
  overflow: hidden;
}

#session-expiration-dialog .session-dialog-orb {
  position: absolute;
  top: -80px;
  right: -60px;
  width: 230px;
  height: 230px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(124, 58, 237, 0.14), transparent 70%);
  pointer-events: none;
}

#session-expiration-dialog .session-dialog-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 14px;
  border-radius: 18px;
  background: linear-gradient(135deg, #d97706, #fbbf24);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  box-shadow: 0 10px 22px rgba(245, 158, 11, 0.35);
}

#session-expiration-dialog .session-dialog-title {
  font-size: 19px;
  font-weight: 800;
  color: var(--text);
  line-height: 1.3;
}

#session-expiration-dialog .session-dialog-text {
  margin-top: 8px;
  color: var(--text-3);
  font-size: 14px;
  line-height: 1.5;
}

.lineUp {
  animation: 3s anim-lineUp ease-out infinite;
}

@keyframes anim-lineUp {
  0% {
    opacity: 0;
    transform: translateY(25%);
  }
  15% {
    opacity: 1;
    transform: translateY(0%);
  }
  100% {
    opacity: 1;
    transform: translateY(0%);
  }
}
</style>
